<template>
  <v-dialog v-model="showModal" width="90%" class="bg-white" @click:outside="$parent.toggleShowAccountSearchModal()" persistent>
    <template v-slot:activator="{ on, showModal }">
      <v-btn
        v-tooltip="'Search accounts'"
        @click="$parent.toggleShowAccountSearchModal()"
        dark
        fab
        bottom
        large
        right
        color="primary"
        fixed
        v-bind="showModal"
        v-on="on"
      >
        <v-icon>mdi-magnify</v-icon>
      </v-btn>
    </template>

    <v-card class="hoh-entry-form">
      <v-card-title class="headline primary white--text" primary-title>
        Search Account
        <v-spacer></v-spacer>
        <v-btn @click="$parent.toggleShowAccountSearchModal()" left text fab small color="white"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-container fluid v-if="hasAccessToPage" class="bg-white">
        <SearchedAccountsCards v-on:toggleModal="$parent.toggleShowAccountSearchModal()" />
      </v-container>
      <NoAccessMessage v-else-if="hasAccessToPage == false" />
    </v-card>
  </v-dialog>
</template>

<script>
import SearchedAccountsCards from '@/components/AccountSearchComponent/components/searched-account-cards'; //'@/views/AccountSearchPage/components/searched-account-cards.vue';
import SharedFunctions from '@/mixins/SharedFunctions.vue';
// import NoAccessMessage from '@/components/generic/no-access-message.vue';

export default {
  props: ['showModal'],
  mixins: [SharedFunctions],
  components: {
    SearchedAccountsCards
  },
  data() {
    return {
      hasAccessToPage: null
    };
  },
  watch: {
    showModal(n) {
      setTimeout(() => {
        if (n) document.getElementById('search-accounts-input').focus();
      }, 200);
    }
  },
  created() {
    window.addEventListener('keydown', (e) => {
      if (e.key == 'Escape') this.showModal = false;//closeForm();
    });
    setTimeout(() => (this.hasAccessToPage = this.hasAccessToPageMixin()), 100);
  }
};
</script>

<style>
</style>